import {Component, Renderer2} from '@angular/core';
import {TenantConfig} from './model/tenant-config';
import {TenantConfigService} from './service/tenant-config.service';
import {LuAppLayoutComponent} from './layout/lu-app-layout/lu-app-layout.component';
import {StzhAppLayoutComponent} from './layout/stzh-app-layout/stzh-app-layout.component';

@Component({
    imports: [StzhAppLayoutComponent, LuAppLayoutComponent],
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: true
})
export class AppComponent {
  tenant!: TenantConfig;

  constructor(
    tenantConfigService: TenantConfigService,
    private renderer: Renderer2,
  ) {
    this.tenant = tenantConfigService.current;
    if (this.tenant.content.themeClass) {
      this.renderer.addClass(document.documentElement, this.tenant.content.themeClass);
    }
    document.title = this.tenant.content.title;
    const favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
    favicon.href = this.tenant.content.faviconPath;
    favicon.type = this.tenant.content.faviconPath.endsWith('.svg') ? 'image/svg+xml' : 'image/x-icon';
  }
}
